import script from "./fileTypePolicyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./fileTypePolicyInput.vue?vue&type=script&setup=true&lang=js"

import "./fileTypePolicyInput.vue?vue&type=style&index=0&id=b0e11d46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e11d46"]])

export default __exports__